import { Vue } from "vue-class-component";
import { Credentials } from "@/types/login";
import { authModule } from "@/store/modules/auth.module";

export default class LoginComponent extends Vue {
  
  public formData: Credentials = {
    email: "",
    password: "",
  };

  private listener: any = null;

  created() {
    this.listener = authModule.$watch(module => module.user, user => {
      if (user != null) {
        this.$router.push({ name: "Home" });
      }
    })
  }

  destroyed() {
    console.log('login destroyed')
    if (this.listener != null) {
      this.listener()
    }
  }

  async submit(e: Event) {
    e.preventDefault();
    await authModule.getLogin(this.formData);
  }
}
